import { $t } from '../../composables/i18n'
import { Codebook } from '../Codebook'

export enum GiftVoucherLayoutId {
  FRAME = 'frame',
  PHOTOGRAPH = 'photograph',
}

export class GiftVoucherLayout extends Codebook<GiftVoucherLayoutId> {
  static readonly FRAME = new GiftVoucherLayout(GiftVoucherLayoutId.FRAME, () => $t('Frame'))
  static readonly PHOTOGRAPH = new GiftVoucherLayout(GiftVoucherLayoutId.PHOTOGRAPH, () =>
    $t('Photograph'),
  )

  private constructor(
    public readonly value: GiftVoucherLayoutId,
    public readonly label: () => string,
  ) {
    super(value)
  }
}
